import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Box, Button } from '@mui/material'
import { useChargebackDisputeAccess } from '../../core/context/TenantSettingsContext'
import ProgressIndicatorPageCenter from '../Progress/ProgressIndicatorPageCenter'

// Bloqueia as rotas de disputa por URL direta (ex.: link do e-mail)
export default function DisputeAccessGate({
  children,
}: {
  children: React.ReactNode
}) {
  const access = useChargebackDisputeAccess()
  const navigate = useNavigate()

  if (access === 'loading') return <ProgressIndicatorPageCenter />

  if (access === 'denied') {
    return (
      <Box>
        <Alert severity="info" sx={{ mb: 2 }}>
          Recurso não disponível para sua conta
        </Alert>
        <Button variant="contained" onClick={() => navigate('/dashboard')}>
          Voltar ao Dashboard
        </Button>
      </Box>
    )
  }

  return <>{children}</>
}
